import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { global } from '../../../app.settings';
import { ExportTemplate } from '../../model/export-template.model';
import { ExportOptionCategory } from '../../model/export-option-category.model';
import { ExportFormat } from '../../model/export-format.model';

@Injectable()
export class ExportService {
  constructor(
    private http: HttpClient
  ) {
  }

  public getExportFormats(): Observable<ExportFormat[]> {
    return this.http.get<any>(global.apiUrl + 'export/formats');
  }

  public getExportOptions(source: string): Observable<ExportOptionCategory[]> {
    return this.http.get<any>(global.apiUrl + 'export/options?source=' + source);
  }

  public getExportTemplates(): Observable<ExportTemplate[]> {
    return this.http.get<any>(global.apiUrl + 'export/templates');
  }

  public deleteTemplate(id: number): any {
    return this.http.delete(global.apiUrl + 'export/delete/' + id.toString());
  }

  public saveTemplate(name: string, columns: any): any {
    const parameters = {
      name: name,
      columns: columns
    };

    return this.http.post(global.apiUrl + 'export/save', parameters);
  }

  public requestExport(parameters: any): Observable<any> {
    return this.http.post(global.apiUrl + 'export', parameters, { observe: 'response', responseType: 'arraybuffer' });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-export/service/export.service.ts